// extracted by mini-css-extract-plugin
export default {"amountInput":"jQm7nXL0XgRF5iVXyRog"};